import { SvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

export const CheckboxStripedOutlineIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24">
        <rect
          x="4"
          y="4"
          width="16"
          height="16"
          stroke="currentColor"
          fill="none"
          strokeLinejoin="round"
          strokeDasharray="2 2"
        />
      </svg>
    </SvgIcon>
  );
};
